"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.a11yID = exports.timeObjectKeys = exports.segments = exports.maxAndMins = exports.rangesList = exports.ranges = void 0;
exports.ranges = {
    hrs12: { start: 0, end: 2, segment: 'hrs12' },
    minutes: { start: 3, end: 5, segment: 'minutes' },
    mode: { start: 6, end: 8, segment: 'mode' },
};
exports.rangesList = [exports.ranges.hrs12, exports.ranges.minutes, exports.ranges.mode];
exports.maxAndMins = {
    hrs24: { min: 0, max: 23 },
    hrs12: { min: 1, max: 12 },
    minutes: { min: 0, max: 59 },
};
exports.segments = ['hrs12', 'minutes', 'mode'];
exports.timeObjectKeys = ['hrs24', 'hrs12', 'minutes', 'mode'];
exports.a11yID = 'time-input-polyfill-accessibility-block';
